import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.scss';
import { NAV_ITEMS } from 'config/navigation';
import { useTheme } from 'context/ThemeContext';

export default function Navbar() {

    // Obtener la ubicación actual
    const location = useLocation();
    const { theme, toggleTheme } = useTheme();

    // Función que comprueba si la ruta está activa
    const isActive = (path: string) => location.pathname === path;

    return (
        <nav className="navbar">
            {NAV_ITEMS.filter((item) => !item.hidden).map((item) => (
                <Link key={item.path} to={item.path} data-label={item.label} className={isActive(item.path) ? 'active' : ''}>
                    <span className="nav_label" data-label={item.label}>
                        <span className="nav_label_text">{item.label}</span>
                    </span>
                </Link>
            ))}
            <button
                type="button"
                className="theme_toggle"
                onClick={toggleTheme}
                aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
            >
                <i className={theme === 'dark' ? 'fa-solid fa-sun' : 'fa-solid fa-moon'}></i>
            </button>
        </nav>
    );
}
